<script setup>
import { useInstitutionStore } from '@/stores/institution';
const institutionStore = useInstitutionStore();

defineProps({
  icon: {
    required: true,
    default: 'home',
    type: String,
  },
  backgroundColor: {
    required: true,
    default: 'red',
    type: String,
  },
  moduleName: {
    required: true,
    type: String,
  },
  isExternal: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>

<template>
  <div
    class="sticky z-40 w-full bg-neutral-100 top-0 flex flex-col mt-8 pt-8 pb-8"
  >
    <div
      class="size-16 p-4 rounded-full mx-auto flex items-center justify-center"
      :style="{ backgroundColor: backgroundColor }"
    >
      <fa-icon
        v-if="!isExternal"
        :icon="[`${icon}`, `${icon}`]"
        class="text-2xl text-white"
      />
      <div v-else class="size-full place-content-center">
        <img
          class="w-9"
          v-optimized="{
            size: 'small',
            src: institutionStore.externalConnections[0]?.image?.source,
          }"
          :alt="icon"
        />
      </div>
    </div>
    <div class="h700 mx-auto mt-3">{{ $t(`moduleNames.${moduleName}`) }}</div>
  </div>
</template>
